import { render, staticRenderFns } from "./lossCustomer.vue?vue&type=template&id=efcdeb58&scoped=true"
import script from "./lossCustomer.vue?vue&type=script&lang=js"
export * from "./lossCustomer.vue?vue&type=script&lang=js"
import style0 from "./lossCustomer.vue?vue&type=style&index=0&id=efcdeb58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcdeb58",
  null
  
)

export default component.exports